import Image from 'next/image'
import wellwoodLogo from './wellwood.png'

type IconProps = {
  className?: string
}

const WellwoodLogo: React.FC<IconProps> = ({ ...attributes }) => {
  return <Image src={wellwoodLogo} alt="Wellwood Logo" height={48} {...attributes} />
}

export default WellwoodLogo
